import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator';
import { Row, Col, Card, Button, Form, Image, Badge, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import moment from 'moment';
import Filter from './Filter';
import SimpleModal from "../../../components/modal/SimpleModal";
import LoadingModal from "../../../components/modal/LoadingModal";
import { getBadge, formatAccountNo } from '../../../resources/Utils';

class OnlineRegistrationReportTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: {
        header: null,
        body: null,
        footer: null,
        variant: null,
        show: false
      },
      loadingShow: false
    }
  }

  handleModalClose = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.props.onRefresh();
    this.setState({
      modal: modal,
      selected: [],
      selectedTransaction: []
    });
  }


  render() {

    const { modal, loadingShow } = this.state;
    const {
      mode,
      role,
      accessToken,
      username,
      filterCriteria,
      searchedCriteria,
      reportList,
      reportCount,
      onFilterCriteriaChange,
      onFilterCriteriaReset,
      onFilterCriteriaSubmit,
      onFilterCriteriaExportCSV,
      onTableChange,
      isDownloading
    } = this.props;

    const tableHeader = [
      { text: "ID", dataField: "id", hidden: true },
      { text: "Merchant ID", dataField: "merchantId", hidden: true, headerStyle: { width: '110px'}},
      { text: "Merchant Name", dataField: "merchantName", hidden: true },
      { text: "Requested Date/Time", dataField: "createdDateTime", sort: true },
      { text: "Requested Reference", dataField: "merchantReference", sort: true, },
      { text: "Customer No.", dataField: "customerReference", sort: true, },
      { text: "Other Reference", dataField: "otherReference", sort: true, },
      { text: "Customer Account No.", dataField: "customerAcctNo", sort: true, },
      { text: "Status", dataField: "statusDesc", sort: true, align:'center',headerAlign:'center', headerStyle: { width: '110px'}},
      { text: "Message", dataField: "errorDesc", sort: true, },

    ];

    let tableBody =
      reportList.map((report) => {
        return {
          id: report.id,
          createdDateTime : moment(report.createdDateTime, "YYYYMMDDHHmmss").format("DD-MMM-YYYY HH:mm:ss"),
          merchantId : report.merchantId,
          merchantName : report.merchantName,
          merchantReference : report.merchantReference,
          customerReference : report.customerReference,
          otherReference : report.otherReference,
          customerAcctNo : report.customerAcctNo,
          statusDesc : report.statusDesc,
          errorDesc : report.errorDesc
        };
      });


    const defaultSorted = [{
      dataField: searchedCriteria.tableFilter.sortField, // if dataField is not match to any column you defined, it will be ignored.
      order: searchedCriteria.tableFilter.sortOrder // desc or asc
    }];
    const options = {
      sizePerPage:searchedCriteria.tableFilter.sizePerPage,
      page:searchedCriteria.tableFilter.page,
      custom: true,
      totalSize: reportCount,
      sizePerPageList: [{
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: '75', value: 75
      }, {
        text: '100', value: 100
      }],
      alwaysShowAllBtns: true,
      firstPageText: 'First',
      prePageText: 'Prev',
      nextPageText: 'Next',
      lastPageText: 'Last'
    };

    return (
      <React.Fragment>
        <PaginationProvider pagination={paginationFactory(options)}>
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={tableBody}
              columns={tableHeader}
            >
              {toolkitprops => (
                <Card className="shadow mt-4 mx-auto card-width-1200">
                  <Card.Header className="pt-3 pb-2 bg-white">
                    <Row>
                      <Col sm={12} className="text-scb font-weight-bold">
                        Online Registration Monitoring Report
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm={12}>
                        <Filter
                          criteria={filterCriteria}
                          onChange={onFilterCriteriaChange}
                          onSubmit={onFilterCriteriaSubmit}
                          onReset={onFilterCriteriaReset}
                          onExportCSV={onFilterCriteriaExportCSV}
                          isDownloading={isDownloading}
                          mode={mode}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Row>
                          <Col xs={12}>
                            <BootstrapTable
                              hover
                              striped
                              bordered={false}
                              defaultSorted={defaultSorted}
                              noDataIndication={"No data found"}
                              {...toolkitprops.baseProps}
                              {...paginationTableProps}
                              remote={ {
                                filter: true,
                                pagination: true,
                                sort: true,
                                cellEdit: false
                              } }
                              onTableChange={ onTableChange }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={"auto"} className="mr-auto">
                            <span className="mr-1">Display</span>
                            <SizePerPageDropdownStandalone btnContextual="btn-scb" {...paginationProps} />
                            <span className="ml-1 mr-1">records per page.</span>
                            <PaginationTotalStandalone {...paginationProps} />
                          </Col>
                          <Col sm={"auto"}>
                            <PaginationListStandalone {...paginationProps} />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
        
        <SimpleModal
          onClose={this.handleModalClose}
          modal={modal}
        />
        <LoadingModal show={loadingShow} />
      </React.Fragment>
    );
  }
}

export default OnlineRegistrationReportTable;